import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Envío por email de un listado desde un botón. Mientras la petición está en curso el botón se
 * pinta deshabilitado con `enviandoListado`, y una segunda pulsación no lanza otra petición: el
 * bloqueo va en una ref porque dos pulsaciones seguidas pueden llegar antes de que React vuelva a
 * pintar el botón.
 *
 * @param {Function} crearAccionEnvio - devuelve el thunk que envía el listado. Se llama en el
 *   momento de pulsar, así que lee los filtros que hay en pantalla en ese instante.
 */
export const useEnvioListado = (crearAccionEnvio) => {
    const dispatch = useDispatch();
    const [enviandoListado, setEnviandoListado] = useState(false);
    const envioEnCursoRef = useRef(false);
    const montadoRef = useRef(true);

    useEffect(() => () => {
        montadoRef.current = false;
    }, []);

    const enviarListado = async () => {
        if (envioEnCursoRef.current) return;
        envioEnCursoRef.current = true;
        setEnviandoListado(true);
        try {
            await dispatch(crearAccionEnvio());
        } finally {
            envioEnCursoRef.current = false;
            if (montadoRef.current) setEnviandoListado(false);
        }
    };

    return { enviandoListado, enviarListado };
};
